<script lang="ts">
  import {onMount} from 'svelte';
  import {writable} from 'svelte/store';
  import editorStore from '../../../../lib/editor/editor.store';
  import {user} from '@/store';
  import {tooltip} from '../../../../actions/tippy-action';
  import editorInstance from '../../../../lib/editor/editor';
  import {createImageElement} from '../../../../lib/editor/helpers';

  export let target: string;
  let htmlElement: HTMLElement | null;

  let isShowing = writable(true);
  let rootComponent: any;
  editorStore.subscribe(store => {
    if (store.rootComponent) {
      rootComponent = store.rootComponent;
      const targetElement = store.rootComponent.querySelector(target);
      if (!targetElement) return isShowing.set(false);
      else {
        isShowing.set(targetElement.style.display !== 'none');
      }
    }
  });

  function createLogo() {
    const finalImage = rootComponent.querySelector('#finalImageToExport');
    if (!finalImage) return;
    const src = $user.brandKit?.logoUrl || '';
    const logoElement = createImageElement(src);
    logoElement.setAttribute('data-amelement', 'logo');
    editorInstance.addComponent(logoElement, true);
  }

  function onClick() {
    htmlElement = document.querySelector(target);
    isShowing.update(value => {
      if (!htmlElement && target.includes('logo')) {
        createLogo();
        return true;
      }
      if (!value) {
        htmlElement.style.display = 'block';
      } else {
        htmlElement.style.display = 'none';
      }
      return !value;
    });
  }

  $: cssClass = $isShowing ? 'fa-eye' : 'fa-eye-slash';
</script>

{#if $editorStore.rootComponent}
  <div
    class="ml-auto block cursor-pointer hover:bg-zinc-300"
    use:tooltip={'Show/Hide'}
    on:click|stopPropagation|preventDefault={onClick}
    on:keypress={onClick}
  >
    <i class="fa {cssClass}" />
  </div>
{/if}
